var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isApp)?_c('div',{staticClass:"bar",class:{ 'app-bar': _vm.isApp }},[_c('div',{staticClass:"close iconfont icon-cha",on:{"click":function($event){$event.stopPropagation();return _vm.bindBack.apply(null, arguments)}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }